

const achievements = [
  ["😱", "Extrovert", 0, 0],
  ["😐", "Vibe killer", 0, 1],
  ["😸", "Pussy expert", 0, 2],
  ["💤", "Wet dreams", 0, 3],
  ["👯‍♀️", "Doppelgänger", 0, 4],
  ["🙅‍♂️", "Way off track", 0, 5],
  ["💦", "Impress professor", 0, 6],
  ["✍️", "Helper", 0, 7],
  ["🫰", "Real friend", 0, 8],
  ["🕵️", "Oops, Sherlock", 0, 9],
  ["🦪", "Accio clitoris", 0, 10],
  ["🍒", "Boob guy", 0, 11],
  ["🍑", "Butt guy", 0, 12],
  ["🗡️", "Sir Camelot", 0, 13],
  ["🤓", "Remaining knowledge", 0, 14],
  ["🏊", "The WETs", 0, 15],
];

export default achievements;
